import { VideoSeasonProps } from "modules/video/season/store/actionType";
import { VideoDetailProps } from "modules/video/video_detail/store/actionType";

export enum actionTypes {
  FETCH_VIDEO_EPISODES_REQUEST = "FETCH_VIDEO_EPISODES_REQUEST",
  FETCH_VIDEO_EPISODES_SUCCESS = "FETCH_VIDEO_EPISODES_SUCCESS",
  FETCH_VIDEO_EPISODES_FAIL = "FETCH_VIDEO_EPISODES_FAIL",
  //create series
  CREATE_VIDEO_EPISODE_REQUEST = "CREATE_VIDEO_EPISODE_REQUEST",
  CREATE_VIDEO_EPISODE_SUCCESS = "CREATE_VIDEO_EPISODE_SUCCESS",
  CREATE_VIDEO_EPISODE_FAIL = "CREATE_VIDEO_EPISODE_FAIL",
  //update series
  UPDATE_VIDEO_EPISODE_REQUEST = "UPDATE_VIDEO_EPISODE_REQUEST",
  UPDATE_VIDEO_EPISODE_SUCCESS = "UPDATE_VIDEO_EPISODE_SUCCESS",
  UPDATE_VIDEO_EPISODE_FAIL = "UPDATE_VIDEO_EPISODE_FAIL",
  //delete series
  DELETE_VIDEO_EPISODE_REQUEST = "DELETE_VIDEO_EPISODE_REQUEST",
  DELETE_VIDEO_EPISODE_SUCCESS = "DELETE_VIDEO_EPISODE_SUCCESS",
  DELETE_VIDEO_EPISODE_FAIL = "DELETE_VIDEO_EPISODE_FAIL",
}

export interface GenericVideoEpisodeStateProps {
  isLoading: boolean;
  status: stateStatusType | string;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface CreateEpisodeInput {
  episode_number: number;
  label: string;
  season_id: string;
  season_folder_id: string;
}
export interface UpdateEpisodeInput {
  episode_number: number;
  label: string;
  episode_id: string;
  season_id?: string;
}

export interface VideoEpisodeProps {
  label: string;
  id: string;
  episode_number: number;
  season_id: string;
  video: VideoDetailProps;
  season:VideoSeasonProps;
}

//FetchVideoEpisode
export interface FetchVideoEpisodesRequestAction {
  type: actionTypes.FETCH_VIDEO_EPISODES_REQUEST;
}

export interface FetchVideoEpisodesSuccessAction {
  type: actionTypes.FETCH_VIDEO_EPISODES_SUCCESS;
  payload: VideoEpisodeProps[];
}

export interface FetchVideoEpisodesFailureAction {
  type: actionTypes.FETCH_VIDEO_EPISODES_FAIL;
  payload: string;
}

//CreateVideoEpisode
export interface CreateVideoEpisodeSuccessAction {
  type: actionTypes.CREATE_VIDEO_EPISODE_SUCCESS;
  payload: VideoEpisodeProps;
}
export interface CreateVideoEpisodeFailAction {
  type: actionTypes.CREATE_VIDEO_EPISODE_FAIL;
  payload: string;
}

//UpdateVideoEpisode
export interface UpdateVideoEpisodeSuccessAction {
  type: actionTypes.UPDATE_VIDEO_EPISODE_SUCCESS;
  payload: VideoEpisodeProps;
}
export interface UpdateVideoEpisodeFailAction {
  type: actionTypes.UPDATE_VIDEO_EPISODE_FAIL;
  payload: string;
}

//DeleteVideoEpisode
export interface DeleteVideoEpisodeSuccessAction {
  type: actionTypes.DELETE_VIDEO_EPISODE_SUCCESS;
  payload: string;
}
export interface DeleteVideoEpisodeFailAction {
  type: actionTypes.DELETE_VIDEO_EPISODE_FAIL;
  payload: string;
}

export type VideoEpisodeActions =
  | FetchVideoEpisodesRequestAction
  | FetchVideoEpisodesSuccessAction
  | FetchVideoEpisodesFailureAction
  | CreateVideoEpisodeSuccessAction
  | CreateVideoEpisodeFailAction
  | UpdateVideoEpisodeSuccessAction
  | UpdateVideoEpisodeFailAction
  | DeleteVideoEpisodeSuccessAction
  | DeleteVideoEpisodeFailAction;
